/**
 * @fileoverview gRPC-Web generated client stub for com.livongo.protobuf.grpc.external.chat
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')
const proto = {};
proto.com = {};
proto.com.livongo = {};
proto.com.livongo.protobuf = {};
proto.com.livongo.protobuf.grpc = {};
proto.com.livongo.protobuf.grpc.external = {};
proto.com.livongo.protobuf.grpc.external.chat = require('./chat_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

  /**
   * @private @const {?Object} The credentials to be used to connect
   *    to the server
   */
  this.credentials_ = credentials;

  /**
   * @private @const {?Object} Options for the client
   */
  this.options_ = options;
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.com.livongo.protobuf.grpc.external.chat.CreateOneOnOneChatRequest,
 *   !proto.com.livongo.protobuf.grpc.external.chat.OneOnOneChat>}
 */
const methodInfo_ChatSetupModerator_CreateOneOnOneChat = new grpc.web.AbstractClientBase.MethodInfo(
  proto.com.livongo.protobuf.grpc.external.chat.OneOnOneChat,
  /** @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateOneOnOneChatRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.chat.OneOnOneChat.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateOneOnOneChatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.com.livongo.protobuf.grpc.external.chat.OneOnOneChat)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.chat.OneOnOneChat>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorClient.prototype.createOneOnOneChat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.chat.ChatSetupModerator/CreateOneOnOneChat',
      request,
      metadata || {},
      methodInfo_ChatSetupModerator_CreateOneOnOneChat,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateOneOnOneChatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.chat.OneOnOneChat>}
 *     A native promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorPromiseClient.prototype.createOneOnOneChat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.chat.ChatSetupModerator/CreateOneOnOneChat',
      request,
      metadata || {},
      methodInfo_ChatSetupModerator_CreateOneOnOneChat);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.com.livongo.protobuf.grpc.external.chat.CreateRequestCoachRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_ChatSetupModerator_CreateRequestCoach = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /** @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateRequestCoachRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateRequestCoachRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorClient.prototype.createRequestCoach =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.chat.ChatSetupModerator/CreateRequestCoach',
      request,
      metadata || {},
      methodInfo_ChatSetupModerator_CreateRequestCoach,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateRequestCoachRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     A native promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorPromiseClient.prototype.createRequestCoach =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.chat.ChatSetupModerator/CreateRequestCoach',
      request,
      metadata || {},
      methodInfo_ChatSetupModerator_CreateRequestCoach);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.com.livongo.protobuf.grpc.external.chat.GetSendBirdUserCredentialsRequest,
 *   !proto.com.livongo.protobuf.grpc.external.chat.SendBirdCredentials>}
 */
const methodInfo_ChatSetupModerator_GetSendBirdUserCredentials = new grpc.web.AbstractClientBase.MethodInfo(
  proto.com.livongo.protobuf.grpc.external.chat.SendBirdCredentials,
  /** @param {!proto.com.livongo.protobuf.grpc.external.chat.GetSendBirdUserCredentialsRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.chat.SendBirdCredentials.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.chat.GetSendBirdUserCredentialsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.com.livongo.protobuf.grpc.external.chat.SendBirdCredentials)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.chat.SendBirdCredentials>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorClient.prototype.getSendBirdUserCredentials =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.chat.ChatSetupModerator/GetSendBirdUserCredentials',
      request,
      metadata || {},
      methodInfo_ChatSetupModerator_GetSendBirdUserCredentials,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.chat.GetSendBirdUserCredentialsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.chat.SendBirdCredentials>}
 *     A native promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorPromiseClient.prototype.getSendBirdUserCredentials =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.chat.ChatSetupModerator/GetSendBirdUserCredentials',
      request,
      metadata || {},
      methodInfo_ChatSetupModerator_GetSendBirdUserCredentials);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.com.livongo.protobuf.grpc.external.chat.CreateSendBirdUserForCoachRequest,
 *   !proto.com.livongo.protobuf.grpc.external.chat.SendBirdUser>}
 */
const methodInfo_ChatSetupModerator_CreateSendBirdUserForCoach = new grpc.web.AbstractClientBase.MethodInfo(
  proto.com.livongo.protobuf.grpc.external.chat.SendBirdUser,
  /** @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateSendBirdUserForCoachRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.chat.SendBirdUser.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateSendBirdUserForCoachRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.com.livongo.protobuf.grpc.external.chat.SendBirdUser)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.chat.SendBirdUser>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorClient.prototype.createSendBirdUserForCoach =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.chat.ChatSetupModerator/CreateSendBirdUserForCoach',
      request,
      metadata || {},
      methodInfo_ChatSetupModerator_CreateSendBirdUserForCoach,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateSendBirdUserForCoachRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.chat.SendBirdUser>}
 *     A native promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorPromiseClient.prototype.createSendBirdUserForCoach =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.chat.ChatSetupModerator/CreateSendBirdUserForCoach',
      request,
      metadata || {},
      methodInfo_ChatSetupModerator_CreateSendBirdUserForCoach);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.com.livongo.protobuf.grpc.external.chat.CreateMemberChannelClaimRequest,
 *   !proto.com.livongo.protobuf.grpc.external.chat.MemberChannelJoin>}
 */
const methodInfo_ChatSetupModerator_CreateMemberChannelClaim = new grpc.web.AbstractClientBase.MethodInfo(
  proto.com.livongo.protobuf.grpc.external.chat.MemberChannelJoin,
  /** @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateMemberChannelClaimRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.chat.MemberChannelJoin.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateMemberChannelClaimRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.com.livongo.protobuf.grpc.external.chat.MemberChannelJoin)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.chat.MemberChannelJoin>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorClient.prototype.createMemberChannelClaim =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.chat.ChatSetupModerator/CreateMemberChannelClaim',
      request,
      metadata || {},
      methodInfo_ChatSetupModerator_CreateMemberChannelClaim,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateMemberChannelClaimRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.chat.MemberChannelJoin>}
 *     A native promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorPromiseClient.prototype.createMemberChannelClaim =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.chat.ChatSetupModerator/CreateMemberChannelClaim',
      request,
      metadata || {},
      methodInfo_ChatSetupModerator_CreateMemberChannelClaim);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.com.livongo.protobuf.grpc.external.chat.CreateMemberChannelJoinRequest,
 *   !proto.com.livongo.protobuf.grpc.external.chat.MemberChannelJoin>}
 */
const methodInfo_ChatSetupModerator_CreateMemberChannelJoin = new grpc.web.AbstractClientBase.MethodInfo(
  proto.com.livongo.protobuf.grpc.external.chat.MemberChannelJoin,
  /** @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateMemberChannelJoinRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  proto.com.livongo.protobuf.grpc.external.chat.MemberChannelJoin.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateMemberChannelJoinRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.com.livongo.protobuf.grpc.external.chat.MemberChannelJoin)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.com.livongo.protobuf.grpc.external.chat.MemberChannelJoin>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorClient.prototype.createMemberChannelJoin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.chat.ChatSetupModerator/CreateMemberChannelJoin',
      request,
      metadata || {},
      methodInfo_ChatSetupModerator_CreateMemberChannelJoin,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateMemberChannelJoinRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.com.livongo.protobuf.grpc.external.chat.MemberChannelJoin>}
 *     A native promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorPromiseClient.prototype.createMemberChannelJoin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.chat.ChatSetupModerator/CreateMemberChannelJoin',
      request,
      metadata || {},
      methodInfo_ChatSetupModerator_CreateMemberChannelJoin);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.com.livongo.protobuf.grpc.external.chat.NotifyCoachInitiatedChatRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_ChatSetupModerator_NotifyCoachInitiatedChat = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /** @param {!proto.com.livongo.protobuf.grpc.external.chat.NotifyCoachInitiatedChatRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.chat.NotifyCoachInitiatedChatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorClient.prototype.notifyCoachInitiatedChat =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.chat.ChatSetupModerator/NotifyCoachInitiatedChat',
      request,
      metadata || {},
      methodInfo_ChatSetupModerator_NotifyCoachInitiatedChat,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.chat.NotifyCoachInitiatedChatRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     A native promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorPromiseClient.prototype.notifyCoachInitiatedChat =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.chat.ChatSetupModerator/NotifyCoachInitiatedChat',
      request,
      metadata || {},
      methodInfo_ChatSetupModerator_NotifyCoachInitiatedChat);
};


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.com.livongo.protobuf.grpc.external.chat.CreateJoinCoachToCoachesChannelRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodInfo_ChatSetupModerator_CreateJoinCoachToCoachesChannel = new grpc.web.AbstractClientBase.MethodInfo(
  google_protobuf_empty_pb.Empty,
  /** @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateJoinCoachToCoachesChannelRequest} request */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateJoinCoachToCoachesChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorClient.prototype.createJoinCoachToCoachesChannel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.chat.ChatSetupModerator/CreateJoinCoachToCoachesChannel',
      request,
      metadata || {},
      methodInfo_ChatSetupModerator_CreateJoinCoachToCoachesChannel,
      callback);
};


/**
 * @param {!proto.com.livongo.protobuf.grpc.external.chat.CreateJoinCoachToCoachesChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     A native promise that resolves to the response
 */
proto.com.livongo.protobuf.grpc.external.chat.ChatSetupModeratorPromiseClient.prototype.createJoinCoachToCoachesChannel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/com.livongo.protobuf.grpc.external.chat.ChatSetupModerator/CreateJoinCoachToCoachesChannel',
      request,
      metadata || {},
      methodInfo_ChatSetupModerator_CreateJoinCoachToCoachesChannel);
};


module.exports = proto.com.livongo.protobuf.grpc.external.chat;

